// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client"
import { client } from "./client.gen"
import type {
  AbortFileUploadData,
  AbortFileUploadErrors,
  AbortFileUploadResponses,
  AddConnectorConnectionData,
  AddConnectorConnectionErrors,
  AddConnectorConnectionResponses,
  AppendTelemetryData,
  AppendTelemetryErrors,
  AppendTelemetryResponses,
  CancelAgentRunData,
  CancelAgentRunErrors,
  CancelAgentRunResponses,
  CancelWorkflowInterventionData,
  CancelWorkflowInterventionErrors,
  CancelWorkflowInterventionResponses,
  CancelWorkflowRunData,
  CancelWorkflowRunErrors,
  CancelWorkflowRunResponses,
  CompleteFileUploadData,
  CompleteFileUploadErrors,
  CompleteFileUploadResponses,
  CountObjectsData,
  CountObjectsErrors,
  CountObjectsResponses,
  CreateAgentThreadData,
  CreateAgentThreadErrors,
  CreateAgentThreadResponses,
  CreateAiLimitPolicyData,
  CreateAiLimitPolicyErrors,
  CreateAiLimitPolicyResponses,
  CreateAuthInvitationData,
  CreateAuthInvitationErrors,
  CreateAuthInvitationResponses,
  CreateAuthPersonalAccessTokenData,
  CreateAuthPersonalAccessTokenErrors,
  CreateAuthPersonalAccessTokenResponses,
  CreateAuthServiceAccountAccessTokenData,
  CreateAuthServiceAccountAccessTokenErrors,
  CreateAuthServiceAccountAccessTokenResponses,
  CreateAuthServiceAccountData,
  CreateAuthServiceAccountErrors,
  CreateAuthServiceAccountResponses,
  CreateDeviceAuthorizationData,
  CreateDeviceAuthorizationErrors,
  CreateDeviceAuthorizationResponses,
  CreateFileUploadData,
  CreateFileUploadErrors,
  CreateFileUploadResponses,
  DeleteAiLimitPolicyData,
  DeleteAiLimitPolicyErrors,
  DeleteAiLimitPolicyResponses,
  DisableAuthServiceAccountData,
  DisableAuthServiceAccountErrors,
  DisableAuthServiceAccountResponses,
  DisconnectConnectorConnectionData,
  DisconnectConnectorConnectionErrors,
  DisconnectConnectorConnectionResponses,
  ExchangeDeviceAuthorizationData,
  ExchangeDeviceAuthorizationResponses,
  ExchangeSharedAccessData,
  ExchangeSharedAccessErrors,
  ExchangeSharedAccessResponses,
  ExistsObjectsData,
  ExistsObjectsErrors,
  ExistsObjectsResponses,
  FacetObjectsData,
  FacetObjectsErrors,
  FacetObjectsResponses,
  GetActionData,
  GetActionErrors,
  GetActionResponses,
  GetActionRunData,
  GetActionRunErrors,
  GetActionRunFileContentData,
  GetActionRunFileContentErrors,
  GetActionRunFileContentResponses,
  GetActionRunResponses,
  GetAgentData,
  GetAgentErrors,
  GetAgentMessageFileContentData,
  GetAgentMessageFileContentErrors,
  GetAgentMessageFileContentResponses,
  GetAgentResponses,
  GetAgentRunData,
  GetAgentRunErrors,
  GetAgentRunResponses,
  GetAgentThreadData,
  GetAgentThreadErrors,
  GetAgentThreadResponses,
  GetAiAccountingOverviewData,
  GetAiAccountingOverviewErrors,
  GetAiAccountingOverviewResponses,
  GetAiLimitStatusData,
  GetAiLimitStatusErrors,
  GetAiLimitStatusResponses,
  GetAiLimitSubjectOptionsData,
  GetAiLimitSubjectOptionsErrors,
  GetAiLimitSubjectOptionsResponses,
  GetAuthAccessManagementOptionsData,
  GetAuthAccessManagementOptionsErrors,
  GetAuthAccessManagementOptionsResponses,
  GetAuthInvitationOptionsData,
  GetAuthInvitationOptionsErrors,
  GetAuthInvitationOptionsResponses,
  GetAuthMembershipOptionsData,
  GetAuthMembershipOptionsErrors,
  GetAuthMembershipOptionsResponses,
  GetAuthSessionData,
  GetAuthSessionResponses,
  GetBulkTelemetryHistoryData,
  GetBulkTelemetryHistoryErrors,
  GetBulkTelemetryHistoryResponses,
  GetConnectorConnectionRunData,
  GetConnectorConnectionRunErrors,
  GetConnectorConnectionRunResponses,
  GetConnectorData,
  GetConnectorErrors,
  GetConnectorResponses,
  GetDatasetData,
  GetDatasetErrors,
  GetDatasetResponses,
  GetDatasetVersionData,
  GetDatasetVersionErrors,
  GetDatasetVersionResponses,
  GetLatestTelemetryData,
  GetLatestTelemetryErrors,
  GetLatestTelemetryResponses,
  GetObjectData,
  GetObjectErrors,
  GetObjectFileContentData,
  GetObjectFileContentErrors,
  GetObjectFileContentResponses,
  GetObjectResponses,
  GetObjectTypeData,
  GetObjectTypeErrors,
  GetObjectTypeResponses,
  GetPipelineData,
  GetPipelineErrors,
  GetPipelineResponses,
  GetPipelineRunData,
  GetPipelineRunErrors,
  GetPipelineRunResponses,
  GetProjectInfoData,
  GetProjectInfoResponses,
  GetProjectionData,
  GetProjectionErrors,
  GetProjectionResponses,
  GetProjectionRunData,
  GetProjectionRunErrors,
  GetProjectionRunResponses,
  GetRuleData,
  GetRuleErrors,
  GetRuleResponses,
  GetSharedAccessSessionData,
  GetSharedAccessSessionErrors,
  GetSharedAccessSessionResponses,
  GetStatusData,
  GetStatusResponses,
  GetSyncData,
  GetSyncErrors,
  GetSyncResponses,
  GetTelemetryHistoryData,
  GetTelemetryHistoryErrors,
  GetTelemetryHistoryResponses,
  GetWorkflowAgentNodeExecutionData,
  GetWorkflowAgentNodeExecutionErrors,
  GetWorkflowAgentNodeExecutionResponses,
  GetWorkflowData,
  GetWorkflowErrors,
  GetWorkflowInterventionData,
  GetWorkflowInterventionErrors,
  GetWorkflowInterventionResponses,
  GetWorkflowNodeRunFileContentData,
  GetWorkflowNodeRunFileContentErrors,
  GetWorkflowNodeRunFileContentResponses,
  GetWorkflowResponses,
  GetWorkflowRunData,
  GetWorkflowRunErrors,
  GetWorkflowRunFileContentData,
  GetWorkflowRunFileContentErrors,
  GetWorkflowRunFileContentResponses,
  GetWorkflowRunResponses,
  HeadActionRunFileContentData,
  HeadActionRunFileContentErrors,
  HeadActionRunFileContentResponses,
  HeadAgentMessageFileContentData,
  HeadAgentMessageFileContentErrors,
  HeadAgentMessageFileContentResponses,
  HeadObjectFileContentData,
  HeadObjectFileContentErrors,
  HeadObjectFileContentResponses,
  HeadWorkflowNodeRunFileContentData,
  HeadWorkflowNodeRunFileContentErrors,
  HeadWorkflowNodeRunFileContentResponses,
  HeadWorkflowRunFileContentData,
  HeadWorkflowRunFileContentErrors,
  HeadWorkflowRunFileContentResponses,
  IssueSharedAccessGrantData,
  IssueSharedAccessGrantErrors,
  IssueSharedAccessGrantResponses,
  ListActionRunsData,
  ListActionRunsErrors,
  ListActionRunsResponses,
  ListActionsData,
  ListActionsResponses,
  ListAgentThreadMessagesData,
  ListAgentThreadMessagesErrors,
  ListAgentThreadMessagesResponses,
  ListAgentThreadRunsData,
  ListAgentThreadRunsErrors,
  ListAgentThreadRunsResponses,
  ListAgentThreadsData,
  ListAgentThreadsErrors,
  ListAgentThreadsResponses,
  ListAiLimitPoliciesData,
  ListAiLimitPoliciesErrors,
  ListAiLimitPoliciesResponses,
  ListAiModelCallGroupsData,
  ListAiModelCallGroupsErrors,
  ListAiModelCallGroupsResponses,
  ListAiModelCallsData,
  ListAiModelCallsErrors,
  ListAiModelCallsResponses,
  ListAuthAccessTokensData,
  ListAuthAccessTokensErrors,
  ListAuthAccessTokensResponses,
  ListAuthInvitationsData,
  ListAuthInvitationsErrors,
  ListAuthInvitationsResponses,
  ListAuthMembersData,
  ListAuthMembersErrors,
  ListAuthMembersResponses,
  ListAuthServiceAccountAccessTokensData,
  ListAuthServiceAccountAccessTokensErrors,
  ListAuthServiceAccountAccessTokensResponses,
  ListAuthServiceAccountsData,
  ListAuthServiceAccountsErrors,
  ListAuthServiceAccountsResponses,
  ListAuthSessionsData,
  ListAuthSessionsErrors,
  ListAuthSessionsResponses,
  ListConnectorConnectionsData,
  ListConnectorConnectionsErrors,
  ListConnectorConnectionsResponses,
  ListConnectorsData,
  ListConnectorsResponses,
  ListDatasetRowsData,
  ListDatasetRowsErrors,
  ListDatasetRowsResponses,
  ListDatasetsData,
  ListDatasetsErrors,
  ListDatasetsResponses,
  ListDatasetVersionsData,
  ListDatasetVersionsErrors,
  ListDatasetVersionsResponses,
  ListEventsData,
  ListEventsErrors,
  ListEventsResponses,
  ListLogsData,
  ListLogsErrors,
  ListLogsResponses,
  ListModelsData,
  ListModelsResponses,
  ListObjectsData,
  ListObjectsErrors,
  ListObjectsResponses,
  ListObjectTypesData,
  ListObjectTypesResponses,
  ListPendingConnectorConnectionRunsData,
  ListPendingConnectorConnectionRunsErrors,
  ListPendingConnectorConnectionRunsResponses,
  ListPipelineRunsData,
  ListPipelineRunsErrors,
  ListPipelineRunsResponses,
  ListPipelinesData,
  ListPipelinesResponses,
  ListProjectionRunsData,
  ListProjectionRunsErrors,
  ListProjectionRunsResponses,
  ListProjectionsData,
  ListProjectionsResponses,
  ListRuleStatesData,
  ListRuleStatesErrors,
  ListRuleStatesResponses,
  ListRulesData,
  ListRulesResponses,
  ListSharedAccessGrantsData,
  ListSharedAccessGrantsErrors,
  ListSharedAccessGrantsResponses,
  ListSyncRunsData,
  ListSyncRunsErrors,
  ListSyncRunsResponses,
  ListSyncsData,
  ListSyncsResponses,
  ListWebhookRunsData,
  ListWebhookRunsErrors,
  ListWebhookRunsResponses,
  ListWorkflowInterventionsData,
  ListWorkflowInterventionsErrors,
  ListWorkflowInterventionsResponses,
  ListWorkflowRunsData,
  ListWorkflowRunsErrors,
  ListWorkflowRunsResponses,
  ListWorkflowsData,
  ListWorkflowsResponses,
  PostAgentThreadMessageData,
  PostAgentThreadMessageErrors,
  PostAgentThreadMessageResponses,
  QueryObjectLinksData,
  QueryObjectLinksErrors,
  QueryObjectLinksResponses,
  QueryObjectsData,
  QueryObjectsErrors,
  QueryObjectsResponses,
  ReactivateAuthMemberData,
  ReactivateAuthMemberErrors,
  ReactivateAuthMemberResponses,
  ReauthorizeConnectorConnectionData,
  ReauthorizeConnectorConnectionErrors,
  ReauthorizeConnectorConnectionResponses,
  RecreateAgentThreadSandboxData,
  RecreateAgentThreadSandboxErrors,
  RecreateAgentThreadSandboxResponses,
  RefreshAuthSessionData,
  RefreshAuthSessionErrors,
  RefreshAuthSessionResponses,
  RemoveObjectLinkData,
  RemoveObjectLinkErrors,
  RemoveObjectLinkResponses,
  RequestActionData,
  RequestActionErrors,
  RequestActionResponses,
  RequestPipelineRunData,
  RequestPipelineRunErrors,
  RequestPipelineRunResponses,
  RequestSyncRunData,
  RequestSyncRunErrors,
  RequestSyncRunResponses,
  RequestWorkflowRunData,
  RequestWorkflowRunErrors,
  RequestWorkflowRunResponses,
  RetryAgentRunData,
  RetryAgentRunErrors,
  RetryAgentRunResponses,
  RevokeAuthAccessTokenData,
  RevokeAuthAccessTokenErrors,
  RevokeAuthAccessTokenResponses,
  RevokeAuthInvitationData,
  RevokeAuthInvitationErrors,
  RevokeAuthInvitationResponses,
  RevokeAuthServiceAccountAccessTokenData,
  RevokeAuthServiceAccountAccessTokenErrors,
  RevokeAuthServiceAccountAccessTokenResponses,
  RevokeAuthSessionData,
  RevokeAuthSessionErrors,
  RevokeAuthSessionResponses,
  RevokeConnectorConnectionData,
  RevokeConnectorConnectionErrors,
  RevokeConnectorConnectionResponses,
  RevokeSharedAccessGrantData,
  RevokeSharedAccessGrantErrors,
  RevokeSharedAccessGrantResponses,
  SearchObjectsData,
  SearchObjectsErrors,
  SearchObjectsResponses,
  SelectConnectorConnectionRunAccountData,
  SelectConnectorConnectionRunAccountErrors,
  SelectConnectorConnectionRunAccountResponses,
  SignFileUploadPartData,
  SignFileUploadPartErrors,
  SignFileUploadPartResponses,
  SignOutAllData,
  SignOutAllErrors,
  SignOutAllResponses,
  SignOutData,
  SignOutErrors,
  SignOutResponses,
  SignOutSharedAccessData,
  SignOutSharedAccessErrors,
  SignOutSharedAccessResponses,
  StartConnectorConnectionRunData,
  StartConnectorConnectionRunErrors,
  StartConnectorConnectionRunResponses,
  SubmitWorkflowInterventionData,
  SubmitWorkflowInterventionErrors,
  SubmitWorkflowInterventionResponses,
  SuspendAuthMemberData,
  SuspendAuthMemberErrors,
  SuspendAuthMemberResponses,
  UpdateAiLimitPolicyData,
  UpdateAiLimitPolicyErrors,
  UpdateAiLimitPolicyResponses,
  UpdateAuthMemberGroupsData,
  UpdateAuthMemberGroupsErrors,
  UpdateAuthMemberGroupsResponses,
  UploadFileContentData,
  UploadFileContentErrors,
  UploadFileContentResponses,
  UploadFileRawData,
  UploadFileRawErrors,
  UploadFileRawResponses,
  UpsertObjectData,
  UpsertObjectErrors,
  UpsertObjectLinkData,
  UpsertObjectLinkErrors,
  UpsertObjectLinkResponses,
  UpsertObjectResponses,
} from "./types.gen"

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Start device authorization
 */
export const createDeviceAuthorization = <ThrowOnError extends boolean = false>(
  options: Options<CreateDeviceAuthorizationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateDeviceAuthorizationResponses,
    CreateDeviceAuthorizationErrors,
    ThrowOnError
  >({
    url: "/api/auth/device-authorizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Exchange an approved device authorization
 */
export const exchangeDeviceAuthorization = <ThrowOnError extends boolean = false>(
  options: Options<ExchangeDeviceAuthorizationData, ThrowOnError>
) =>
  (options.client ?? client).post<ExchangeDeviceAuthorizationResponses, unknown, ThrowOnError>({
    url: "/api/auth/device-authorizations/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Refresh a native client's session tokens
 */
export const refreshAuthSession = <ThrowOnError extends boolean = false>(
  options: Options<RefreshAuthSessionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RefreshAuthSessionResponses,
    RefreshAuthSessionErrors,
    ThrowOnError
  >({
    url: "/api/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get current auth session
 */
export const getAuthSession = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthSessionData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAuthSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/session",
    ...options,
  })

/**
 * Sign out current auth session
 */
export const signOut = <ThrowOnError extends boolean = false>(
  options?: Options<SignOutData, ThrowOnError>
) =>
  (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/sign-out",
    ...options,
  })

/**
 * List active sessions for the current user
 */
export const listAuthSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ListAuthSessionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAuthSessionsResponses, ListAuthSessionsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/sessions",
    ...options,
  })

/**
 * Revoke one of the current user's sessions
 */
export const revokeAuthSession = <ThrowOnError extends boolean = false>(
  options: Options<RevokeAuthSessionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RevokeAuthSessionResponses,
    RevokeAuthSessionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/sessions/{sessionId}/revoke",
    ...options,
  })

/**
 * Sign out the current user everywhere (all devices and apps)
 */
export const signOutAll = <ThrowOnError extends boolean = false>(
  options?: Options<SignOutAllData, ThrowOnError>
) =>
  (options?.client ?? client).post<SignOutAllResponses, SignOutAllErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/sign-out-all",
    ...options,
  })

/**
 * Get auth access-token management options
 */
export const getAuthAccessManagementOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthAccessManagementOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAuthAccessManagementOptionsResponses,
    GetAuthAccessManagementOptionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/access-management-options",
    ...options,
  })

/**
 * List personal access tokens for the current user
 */
export const listAuthAccessTokens = <ThrowOnError extends boolean = false>(
  options?: Options<ListAuthAccessTokensData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAuthAccessTokensResponses,
    ListAuthAccessTokensErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/access-tokens",
    ...options,
  })

/**
 * Create a personal access token
 */
export const createAuthPersonalAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateAuthPersonalAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAuthPersonalAccessTokenResponses,
    CreateAuthPersonalAccessTokenErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/access-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Revoke one of the current user's personal access tokens
 */
export const revokeAuthAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<RevokeAuthAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RevokeAuthAccessTokenResponses,
    RevokeAuthAccessTokenErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/access-tokens/{tokenId}/revoke",
    ...options,
  })

/**
 * List auth service accounts
 */
export const listAuthServiceAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<ListAuthServiceAccountsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAuthServiceAccountsResponses,
    ListAuthServiceAccountsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts",
    ...options,
  })

/**
 * Create an auth service account
 */
export const createAuthServiceAccount = <ThrowOnError extends boolean = false>(
  options: Options<CreateAuthServiceAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAuthServiceAccountResponses,
    CreateAuthServiceAccountErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Disable an auth service account
 */
export const disableAuthServiceAccount = <ThrowOnError extends boolean = false>(
  options: Options<DisableAuthServiceAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DisableAuthServiceAccountResponses,
    DisableAuthServiceAccountErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts/{serviceAccountId}/disable",
    ...options,
  })

/**
 * List access tokens for an auth service account
 */
export const listAuthServiceAccountAccessTokens = <ThrowOnError extends boolean = false>(
  options: Options<ListAuthServiceAccountAccessTokensData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAuthServiceAccountAccessTokensResponses,
    ListAuthServiceAccountAccessTokensErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts/{serviceAccountId}/access-tokens",
    ...options,
  })

/**
 * Create an access token for an auth service account
 */
export const createAuthServiceAccountAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateAuthServiceAccountAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAuthServiceAccountAccessTokenResponses,
    CreateAuthServiceAccountAccessTokenErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts/{serviceAccountId}/access-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Revoke an access token for an auth service account
 */
export const revokeAuthServiceAccountAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<RevokeAuthServiceAccountAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RevokeAuthServiceAccountAccessTokenResponses,
    RevokeAuthServiceAccountAccessTokenErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/service-accounts/{serviceAccountId}/access-tokens/{tokenId}/revoke",
    ...options,
  })

/**
 * List auth invitations
 */
export const listAuthInvitations = <ThrowOnError extends boolean = false>(
  options?: Options<ListAuthInvitationsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAuthInvitationsResponses,
    ListAuthInvitationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/invitations",
    ...options,
  })

/**
 * Create an auth invitation
 */
export const createAuthInvitation = <ThrowOnError extends boolean = false>(
  options: Options<CreateAuthInvitationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAuthInvitationResponses,
    CreateAuthInvitationErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/invitations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get auth invitation options
 */
export const getAuthInvitationOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthInvitationOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAuthInvitationOptionsResponses,
    GetAuthInvitationOptionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/invitation-options",
    ...options,
  })

/**
 * Revoke an auth invitation
 */
export const revokeAuthInvitation = <ThrowOnError extends boolean = false>(
  options: Options<RevokeAuthInvitationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RevokeAuthInvitationResponses,
    RevokeAuthInvitationErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/invitations/{invitationId}/revoke",
    ...options,
  })

/**
 * Get auth membership management options
 */
export const getAuthMembershipOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMembershipOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAuthMembershipOptionsResponses,
    GetAuthMembershipOptionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/membership-options",
    ...options,
  })

/**
 * List auth members
 */
export const listAuthMembers = <ThrowOnError extends boolean = false>(
  options?: Options<ListAuthMembersData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAuthMembersResponses, ListAuthMembersErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/members",
    ...options,
  })

/**
 * Update an auth member's groups
 */
export const updateAuthMemberGroups = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAuthMemberGroupsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateAuthMemberGroupsResponses,
    UpdateAuthMemberGroupsErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/members/{userId}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Suspend an auth member
 */
export const suspendAuthMember = <ThrowOnError extends boolean = false>(
  options: Options<SuspendAuthMemberData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SuspendAuthMemberResponses,
    SuspendAuthMemberErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/members/{userId}/suspend",
    ...options,
  })

/**
 * Reactivate an auth member
 */
export const reactivateAuthMember = <ThrowOnError extends boolean = false>(
  options: Options<ReactivateAuthMemberData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ReactivateAuthMemberResponses,
    ReactivateAuthMemberErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/auth/members/{userId}/reactivate",
    ...options,
  })

/**
 * Get project AI usage and cost analytics
 */
export const getAiAccountingOverview = <ThrowOnError extends boolean = false>(
  options: Options<GetAiAccountingOverviewData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAiAccountingOverviewResponses,
    GetAiAccountingOverviewErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/accounting/overview",
    ...options,
  })

/**
 * List project AI model-call accounting records
 */
export const listAiModelCalls = <ThrowOnError extends boolean = false>(
  options: Options<ListAiModelCallsData, ThrowOnError>
) =>
  (options.client ?? client).get<ListAiModelCallsResponses, ListAiModelCallsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/model-calls",
    ...options,
  })

/**
 * List project AI usage-limit policies
 */
export const listAiLimitPolicies = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiLimitPoliciesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAiLimitPoliciesResponses,
    ListAiLimitPoliciesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits",
    ...options,
  })

/**
 * Create an AI usage-limit policy
 */
export const createAiLimitPolicy = <ThrowOnError extends boolean = false>(
  options: Options<CreateAiLimitPolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAiLimitPolicyResponses,
    CreateAiLimitPolicyErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get current project AI usage-limit status
 */
export const getAiLimitStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiLimitStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAiLimitStatusResponses, GetAiLimitStatusErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits/status",
    ...options,
  })

/**
 * Get selectable AI usage-limit subjects
 *
 * Lists registered groups and auth principals available for AI usage-limit policies.
 */
export const getAiLimitSubjectOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiLimitSubjectOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAiLimitSubjectOptionsResponses,
    GetAiLimitSubjectOptionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits/subjects",
    ...options,
  })

/**
 * Delete an AI usage-limit policy
 */
export const deleteAiLimitPolicy = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAiLimitPolicyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteAiLimitPolicyResponses,
    DeleteAiLimitPolicyErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits/{limitId}",
    ...options,
  })

/**
 * Update an AI usage-limit policy
 */
export const updateAiLimitPolicy = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAiLimitPolicyData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateAiLimitPolicyResponses,
    UpdateAiLimitPolicyErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/limits/{limitId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List AI model calls grouped by initiating execution
 */
export const listAiModelCallGroups = <ThrowOnError extends boolean = false>(
  options: Options<ListAiModelCallGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAiModelCallGroupsResponses,
    ListAiModelCallGroupsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/ai/model-call-groups",
    ...options,
  })

/**
 * Get current project metadata
 */
export const getProjectInfo = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectInfoData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetProjectInfoResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/project",
    ...options,
  })

/**
 * Get runtime status
 */
export const getStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/status",
    ...options,
  })

/**
 * List registered connectors
 */
export const listConnectors = <ThrowOnError extends boolean = false>(
  options?: Options<ListConnectorsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListConnectorsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/connectors",
    ...options,
  })

/**
 * Get connector metadata
 */
export const getConnector = <ThrowOnError extends boolean = false>(
  options: Options<GetConnectorData, ThrowOnError>
) =>
  (options.client ?? client).get<GetConnectorResponses, GetConnectorErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/connectors/{connectorId}",
    ...options,
  })

/**
 * List connector connections
 */
export const listConnectorConnections = <ThrowOnError extends boolean = false>(
  options: Options<ListConnectorConnectionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListConnectorConnectionsResponses,
    ListConnectorConnectionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/connectors/{connectorId}/connections",
    ...options,
  })

/**
 * Disconnect a connector account
 */
export const disconnectConnectorConnection = <ThrowOnError extends boolean = false>(
  options: Options<DisconnectConnectorConnectionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DisconnectConnectorConnectionResponses,
    DisconnectConnectorConnectionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connections/{connectionId}",
    ...options,
  })

/**
 * Revoke a connector authorization
 */
export const revokeConnectorConnection = <ThrowOnError extends boolean = false>(
  options: Options<RevokeConnectorConnectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RevokeConnectorConnectionResponses,
    RevokeConnectorConnectionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connections/{connectionId}/revoke",
    ...options,
  })

/**
 * List the initiating user's pending connector connection runs
 */
export const listPendingConnectorConnectionRuns = <ThrowOnError extends boolean = false>(
  options: Options<ListPendingConnectorConnectionRunsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPendingConnectorConnectionRunsResponses,
    ListPendingConnectorConnectionRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/connectors/{connectorId}/connection-runs",
    ...options,
  })

/**
 * Start a connector connection run
 */
export const startConnectorConnectionRun = <ThrowOnError extends boolean = false>(
  options: Options<StartConnectorConnectionRunData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StartConnectorConnectionRunResponses,
    StartConnectorConnectionRunErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connection-runs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get a connector connection run
 */
export const getConnectorConnectionRun = <ThrowOnError extends boolean = false>(
  options: Options<GetConnectorConnectionRunData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetConnectorConnectionRunResponses,
    GetConnectorConnectionRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/connectors/{connectorId}/connection-runs/{runId}",
    ...options,
  })

/**
 * Add a connector connection from an existing authorization
 */
export const addConnectorConnection = <ThrowOnError extends boolean = false>(
  options: Options<AddConnectorConnectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddConnectorConnectionResponses,
    AddConnectorConnectionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connections/{connectionId}/connection-runs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Select a connector account
 */
export const selectConnectorConnectionRunAccount = <ThrowOnError extends boolean = false>(
  options: Options<SelectConnectorConnectionRunAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SelectConnectorConnectionRunAccountResponses,
    SelectConnectorConnectionRunAccountErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connection-runs/{runId}/selection",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Reauthorize a connector connection
 */
export const reauthorizeConnectorConnection = <ThrowOnError extends boolean = false>(
  options: Options<ReauthorizeConnectorConnectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ReauthorizeConnectorConnectionResponses,
    ReauthorizeConnectorConnectionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/connectors/{connectorId}/connections/{connectionId}/reauthorize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List registered datasets
 */
export const listDatasets = <ThrowOnError extends boolean = false>(
  options?: Options<ListDatasetsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListDatasetsResponses, ListDatasetsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/datasets",
    ...options,
  })

/**
 * Get dataset metadata
 */
export const getDataset = <ThrowOnError extends boolean = false>(
  options: Options<GetDatasetData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDatasetResponses, GetDatasetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/datasets/{datasetId}",
    ...options,
  })

/**
 * List dataset versions
 */
export const listDatasetVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListDatasetVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListDatasetVersionsResponses,
    ListDatasetVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/datasets/{datasetId}/versions",
    ...options,
  })

/**
 * Get dataset version
 */
export const getDatasetVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetDatasetVersionData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDatasetVersionResponses, GetDatasetVersionErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/datasets/{datasetId}/versions/{versionId}",
      ...options,
    }
  )

/**
 * Preview dataset rows
 */
export const listDatasetRows = <ThrowOnError extends boolean = false>(
  options: Options<ListDatasetRowsData, ThrowOnError>
) =>
  (options.client ?? client).get<ListDatasetRowsResponses, ListDatasetRowsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/datasets/{datasetId}/rows",
    ...options,
  })

/**
 * List registered syncs
 */
export const listSyncs = <ThrowOnError extends boolean = false>(
  options?: Options<ListSyncsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListSyncsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/syncs",
    ...options,
  })

/**
 * Get sync metadata
 */
export const getSync = <ThrowOnError extends boolean = false>(
  options: Options<GetSyncData, ThrowOnError>
) =>
  (options.client ?? client).get<GetSyncResponses, GetSyncErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/syncs/{syncId}",
    ...options,
  })

/**
 * List sync run history
 */
export const listSyncRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListSyncRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListSyncRunsResponses, ListSyncRunsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/sync-runs",
    ...options,
  })

/**
 * Request a sync run
 */
export const requestSyncRun = <ThrowOnError extends boolean = false>(
  options: Options<RequestSyncRunData, ThrowOnError>
) =>
  (options.client ?? client).post<RequestSyncRunResponses, RequestSyncRunErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/syncs/{syncId}/runs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List registered pipelines
 */
export const listPipelines = <ThrowOnError extends boolean = false>(
  options?: Options<ListPipelinesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListPipelinesResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/pipelines",
    ...options,
  })

/**
 * Get pipeline metadata
 */
export const getPipeline = <ThrowOnError extends boolean = false>(
  options: Options<GetPipelineData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPipelineResponses, GetPipelineErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/pipelines/{pipelineId}",
    ...options,
  })

/**
 * List pipeline run history
 */
export const listPipelineRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListPipelineRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListPipelineRunsResponses, ListPipelineRunsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/pipeline-runs",
    ...options,
  })

/**
 * Get pipeline run detail
 */
export const getPipelineRun = <ThrowOnError extends boolean = false>(
  options: Options<GetPipelineRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPipelineRunResponses, GetPipelineRunErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/pipeline-runs/{runId}",
    ...options,
  })

/**
 * Request a pipeline run
 */
export const requestPipelineRun = <ThrowOnError extends boolean = false>(
  options: Options<RequestPipelineRunData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestPipelineRunResponses,
    RequestPipelineRunErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/pipelines/{pipelineId}/runs",
    ...options,
  })

/**
 * List registered workflows
 */
export const listWorkflows = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListWorkflowsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflows",
    ...options,
  })

/**
 * Get workflow metadata
 */
export const getWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowData, ThrowOnError>
) =>
  (options.client ?? client).get<GetWorkflowResponses, GetWorkflowErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflows/{workflowId}",
    ...options,
  })

/**
 * List workflow interventions
 */
export const listWorkflowInterventions = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowInterventionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListWorkflowInterventionsResponses,
    ListWorkflowInterventionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/workflow-interventions",
    ...options,
  })

/**
 * Get workflow intervention detail
 */
export const getWorkflowIntervention = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowInterventionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWorkflowInterventionResponses,
    GetWorkflowInterventionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/workflow-interventions/{interventionId}",
    ...options,
  })

/**
 * Submit a workflow intervention response
 */
export const submitWorkflowIntervention = <ThrowOnError extends boolean = false>(
  options: Options<SubmitWorkflowInterventionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitWorkflowInterventionResponses,
    SubmitWorkflowInterventionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-interventions/{interventionId}/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Cancel a workflow intervention
 */
export const cancelWorkflowIntervention = <ThrowOnError extends boolean = false>(
  options: Options<CancelWorkflowInterventionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CancelWorkflowInterventionResponses,
    CancelWorkflowInterventionErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-interventions/{interventionId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List workflow run history
 */
export const listWorkflowRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListWorkflowRunsResponses, ListWorkflowRunsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs",
    ...options,
  })

/**
 * Get workflow run detail
 */
export const getWorkflowRun = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetWorkflowRunResponses, GetWorkflowRunErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}",
    ...options,
  })

/**
 * Get workflow agent node execution detail
 */
export const getWorkflowAgentNodeExecution = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowAgentNodeExecutionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWorkflowAgentNodeExecutionResponses,
    GetWorkflowAgentNodeExecutionErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/nodes/{nodeKey}/agent-execution",
    ...options,
  })

/**
 * Cancel a workflow run
 */
export const cancelWorkflowRun = <ThrowOnError extends boolean = false>(
  options: Options<CancelWorkflowRunData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CancelWorkflowRunResponses,
    CancelWorkflowRunErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get workflow run file content
 */
export const getWorkflowRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWorkflowRunFileContentResponses,
    GetWorkflowRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/files/content",
    ...options,
  })

/**
 * Head workflow run file content
 */
export const headWorkflowRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<HeadWorkflowRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadWorkflowRunFileContentResponses,
    HeadWorkflowRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/files/content",
    ...options,
  })

/**
 * Get workflow node run file content
 */
export const getWorkflowNodeRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowNodeRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWorkflowNodeRunFileContentResponses,
    GetWorkflowNodeRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/nodes/{nodeKey}/files/content",
    ...options,
  })

/**
 * Head workflow node run file content
 */
export const headWorkflowNodeRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<HeadWorkflowNodeRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadWorkflowNodeRunFileContentResponses,
    HeadWorkflowNodeRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflow-runs/{runId}/nodes/{nodeKey}/files/content",
    ...options,
  })

/**
 * Request a workflow run
 */
export const requestWorkflowRun = <ThrowOnError extends boolean = false>(
  options: Options<RequestWorkflowRunData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestWorkflowRunResponses,
    RequestWorkflowRunErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/workflows/{workflowId}/runs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List registered rules
 */
export const listRules = <ThrowOnError extends boolean = false>(
  options?: Options<ListRulesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListRulesResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/rules",
    ...options,
  })

/**
 * Get rule metadata
 */
export const getRule = <ThrowOnError extends boolean = false>(
  options: Options<GetRuleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetRuleResponses, GetRuleErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/rules/{ruleId}",
    ...options,
  })

/**
 * List active rule states
 */
export const listRuleStates = <ThrowOnError extends boolean = false>(
  options?: Options<ListRuleStatesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListRuleStatesResponses, ListRuleStatesErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/rule-states",
    ...options,
  })

/**
 * List shared-access grants
 */
export const listSharedAccessGrants = <ThrowOnError extends boolean = false>(
  options: Options<ListSharedAccessGrantsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListSharedAccessGrantsResponses,
    ListSharedAccessGrantsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/share-grants",
    ...options,
  })

/**
 * Issue a shared-access grant
 */
export const issueSharedAccessGrant = <ThrowOnError extends boolean = false>(
  options: Options<IssueSharedAccessGrantData, ThrowOnError>
) =>
  (options.client ?? client).post<
    IssueSharedAccessGrantResponses,
    IssueSharedAccessGrantErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/share-grants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Revoke a shared-access grant
 */
export const revokeSharedAccessGrant = <ThrowOnError extends boolean = false>(
  options: Options<RevokeSharedAccessGrantData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RevokeSharedAccessGrantResponses,
    RevokeSharedAccessGrantErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/share-grants/{grantId}",
    ...options,
  })

/**
 * Exchange a shared link for a short-lived session
 */
export const exchangeSharedAccess = <ThrowOnError extends boolean = false>(
  options: Options<ExchangeSharedAccessData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExchangeSharedAccessResponses,
    ExchangeSharedAccessErrors,
    ThrowOnError
  >({
    url: "/api/shared-access/{grantId}/exchange",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get the current shared-access session
 */
export const getSharedAccessSession = <ThrowOnError extends boolean = false>(
  options: Options<GetSharedAccessSessionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSharedAccessSessionResponses,
    GetSharedAccessSessionErrors,
    ThrowOnError
  >({ url: "/api/shared-access/{grantId}/session", ...options })

/**
 * Sign out a shared-access session
 */
export const signOutSharedAccess = <ThrowOnError extends boolean = false>(
  options: Options<SignOutSharedAccessData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SignOutSharedAccessResponses,
    SignOutSharedAccessErrors,
    ThrowOnError
  >({
    security: [{ name: "x-sixb-csrf", type: "apiKey" }],
    url: "/api/shared-access/{grantId}/sign-out",
    ...options,
  })

/**
 * List registered object types
 */
export const listObjectTypes = <ThrowOnError extends boolean = false>(
  options?: Options<ListObjectTypesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListObjectTypesResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/object-types",
    ...options,
  })

/**
 * Get object type definition
 */
export const getObjectType = <ThrowOnError extends boolean = false>(
  options: Options<GetObjectTypeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetObjectTypeResponses, GetObjectTypeErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/object-types/{objectTypeId}",
    ...options,
  })

/**
 * Search objects
 */
export const searchObjects = <ThrowOnError extends boolean = false>(
  options: Options<SearchObjectsData, ThrowOnError>
) =>
  (options.client ?? client).get<SearchObjectsResponses, SearchObjectsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/search",
    ...options,
  })

/**
 * List objects
 */
export const listObjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListObjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListObjectsResponses, ListObjectsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects",
    ...options,
  })

/**
 * Query objects
 */
export const queryObjects = <ThrowOnError extends boolean = false>(
  options: Options<QueryObjectsData, ThrowOnError>
) =>
  (options.client ?? client).post<QueryObjectsResponses, QueryObjectsErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/query",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Query object links
 */
export const queryObjectLinks = <ThrowOnError extends boolean = false>(
  options: Options<QueryObjectLinksData, ThrowOnError>
) =>
  (options.client ?? client).post<QueryObjectLinksResponses, QueryObjectLinksErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/query/links",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Count objects
 */
export const countObjects = <ThrowOnError extends boolean = false>(
  options: Options<CountObjectsData, ThrowOnError>
) =>
  (options.client ?? client).post<CountObjectsResponses, CountObjectsErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/query/count",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Check object existence
 */
export const existsObjects = <ThrowOnError extends boolean = false>(
  options: Options<ExistsObjectsData, ThrowOnError>
) =>
  (options.client ?? client).post<ExistsObjectsResponses, ExistsObjectsErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/query/exists",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Facet objects
 */
export const facetObjects = <ThrowOnError extends boolean = false>(
  options: Options<FacetObjectsData, ThrowOnError>
) =>
  (options.client ?? client).post<FacetObjectsResponses, FacetObjectsErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/query/facets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get object file content
 */
export const getObjectFileContent = <ThrowOnError extends boolean = false>(
  options: Options<GetObjectFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetObjectFileContentResponses,
    GetObjectFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/files/content",
    ...options,
  })

/**
 * Head object file content
 */
export const headObjectFileContent = <ThrowOnError extends boolean = false>(
  options: Options<HeadObjectFileContentData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadObjectFileContentResponses,
    HeadObjectFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/files/content",
    ...options,
  })

/**
 * Get object by id
 */
export const getObject = <ThrowOnError extends boolean = false>(
  options: Options<GetObjectData, ThrowOnError>
) =>
  (options.client ?? client).get<GetObjectResponses, GetObjectErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}",
    ...options,
  })

/**
 * Create or update object
 */
export const upsertObject = <ThrowOnError extends boolean = false>(
  options: Options<UpsertObjectData, ThrowOnError>
) =>
  (options.client ?? client).put<UpsertObjectResponses, UpsertObjectErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List registered actions
 */
export const listActions = <ThrowOnError extends boolean = false>(
  options?: Options<ListActionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListActionsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/actions",
    ...options,
  })

/**
 * Get action metadata
 */
export const getAction = <ThrowOnError extends boolean = false>(
  options: Options<GetActionData, ThrowOnError>
) =>
  (options.client ?? client).get<GetActionResponses, GetActionErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/actions/{actionId}",
    ...options,
  })

/**
 * Request an action
 */
export const requestAction = <ThrowOnError extends boolean = false>(
  options: Options<RequestActionData, ThrowOnError>
) =>
  (options.client ?? client).post<RequestActionResponses, RequestActionErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/actions/{actionId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Upload a file
 */
export const uploadFileRaw = <ThrowOnError extends boolean = false>(
  options: Options<UploadFileRawData, ThrowOnError>
) =>
  (options.client ?? client).post<UploadFileRawResponses, UploadFileRawErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  })

/**
 * Create a staged file upload
 */
export const createFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<CreateFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateFileUploadResponses, CreateFileUploadErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/files/uploads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Upload staged file content through Sixb
 */
export const uploadFileContent = <ThrowOnError extends boolean = false>(
  options: Options<UploadFileContentData, ThrowOnError>
) =>
  (options.client ?? client).put<UploadFileContentResponses, UploadFileContentErrors, ThrowOnError>(
    {
      bodySerializer: null,
      security: [
        { name: "x-sixb-csrf", type: "apiKey" },
        { scheme: "bearer", type: "http" },
      ],
      url: "/api/files/uploads/{uploadId}/content",
      ...options,
      headers: {
        "Content-Type": "application/octet-stream",
        ...options.headers,
      },
    }
  )

/**
 * Sign a staged multipart upload part
 */
export const signFileUploadPart = <ThrowOnError extends boolean = false>(
  options: Options<SignFileUploadPartData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SignFileUploadPartResponses,
    SignFileUploadPartErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/files/uploads/{uploadId}/parts/{partNumber}",
    ...options,
  })

/**
 * Complete a staged file upload
 */
export const completeFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<CompleteFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CompleteFileUploadResponses,
    CompleteFileUploadErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/files/uploads/{uploadId}/complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Abort a staged file upload
 */
export const abortFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<AbortFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<AbortFileUploadResponses, AbortFileUploadErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/files/uploads/{uploadId}/abort",
    ...options,
  })

/**
 * List action run history
 */
export const listActionRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListActionRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListActionRunsResponses, ListActionRunsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/action-runs",
    ...options,
  })

/**
 * Get action run detail
 */
export const getActionRun = <ThrowOnError extends boolean = false>(
  options: Options<GetActionRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetActionRunResponses, GetActionRunErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/action-runs/{runId}",
    ...options,
  })

/**
 * Get action run file content
 */
export const getActionRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<GetActionRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetActionRunFileContentResponses,
    GetActionRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/action-runs/{runId}/files/content",
    ...options,
  })

/**
 * Head action run file content
 */
export const headActionRunFileContent = <ThrowOnError extends boolean = false>(
  options: Options<HeadActionRunFileContentData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadActionRunFileContentResponses,
    HeadActionRunFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/action-runs/{runId}/files/content",
    ...options,
  })

/**
 * Get the project Agent
 */
export const getAgent = <ThrowOnError extends boolean = false>(
  options?: Options<GetAgentData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAgentResponses, GetAgentErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent",
    ...options,
  })

/**
 * List agent threads
 */
export const listAgentThreads = <ThrowOnError extends boolean = false>(
  options?: Options<ListAgentThreadsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAgentThreadsResponses, ListAgentThreadsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent-threads",
    ...options,
  })

/**
 * Create an agent thread
 */
export const createAgentThread = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentThreadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAgentThreadResponses,
    CreateAgentThreadErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get agent thread
 */
export const getAgentThread = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentThreadData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAgentThreadResponses, GetAgentThreadErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent-threads/{threadId}",
    ...options,
  })

/**
 * Explicitly recreate an unavailable or uncertain workspace without deleting its previous state
 */
export const recreateAgentThreadSandbox = <ThrowOnError extends boolean = false>(
  options: Options<RecreateAgentThreadSandboxData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecreateAgentThreadSandboxResponses,
    RecreateAgentThreadSandboxErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/sandbox/recreate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List agent thread messages
 */
export const listAgentThreadMessages = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentThreadMessagesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAgentThreadMessagesResponses,
    ListAgentThreadMessagesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent-threads/{threadId}/messages",
    ...options,
  })

/**
 * Post an agent thread message
 */
export const postAgentThreadMessage = <ThrowOnError extends boolean = false>(
  options: Options<PostAgentThreadMessageData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostAgentThreadMessageResponses,
    PostAgentThreadMessageErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get agent message file content
 */
export const getAgentMessageFileContent = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentMessageFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAgentMessageFileContentResponses,
    GetAgentMessageFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/messages/{messageId}/files/content",
    ...options,
  })

/**
 * Head agent message file content
 */
export const headAgentMessageFileContent = <ThrowOnError extends boolean = false>(
  options: Options<HeadAgentMessageFileContentData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadAgentMessageFileContentResponses,
    HeadAgentMessageFileContentErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/messages/{messageId}/files/content",
    ...options,
  })

/**
 * Cancel an agent thread's active run
 */
export const cancelAgentRun = <ThrowOnError extends boolean = false>(
  options: Options<CancelAgentRunData, ThrowOnError>
) =>
  (options.client ?? client).post<CancelAgentRunResponses, CancelAgentRunErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Retry a failed agent run
 */
export const retryAgentRun = <ThrowOnError extends boolean = false>(
  options: Options<RetryAgentRunData, ThrowOnError>
) =>
  (options.client ?? client).post<RetryAgentRunResponses, RetryAgentRunErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/agent-threads/{threadId}/runs/{runId}/retry",
    ...options,
  })

/**
 * List an agent thread's runs
 */
export const listAgentThreadRuns = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentThreadRunsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAgentThreadRunsResponses,
    ListAgentThreadRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent-threads/{threadId}/runs",
    ...options,
  })

/**
 * Get agent run
 */
export const getAgentRun = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAgentRunResponses, GetAgentRunErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/agent-runs/{runId}",
    ...options,
  })

/**
 * List the project model catalog
 */
export const listModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListModelsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListModelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/models",
    ...options,
  })

/**
 * Remove object link
 */
export const removeObjectLink = <ThrowOnError extends boolean = false>(
  options: Options<RemoveObjectLinkData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveObjectLinkResponses,
    RemoveObjectLinkErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/links/{linkId}",
    ...options,
  })

/**
 * Create or update object link
 */
export const upsertObjectLink = <ThrowOnError extends boolean = false>(
  options: Options<UpsertObjectLinkData, ThrowOnError>
) =>
  (options.client ?? client).put<UpsertObjectLinkResponses, UpsertObjectLinkErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/links/{linkId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Append telemetry point
 */
export const appendTelemetry = <ThrowOnError extends boolean = false>(
  options: Options<AppendTelemetryData, ThrowOnError>
) =>
  (options.client ?? client).post<AppendTelemetryResponses, AppendTelemetryErrors, ThrowOnError>({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/telemetry/{propertyId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get bulk telemetry history
 */
export const getBulkTelemetryHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetBulkTelemetryHistoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetBulkTelemetryHistoryResponses,
    GetBulkTelemetryHistoryErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-sixb-csrf", type: "apiKey" },
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/telemetry/history",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get telemetry history
 */
export const getTelemetryHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetTelemetryHistoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTelemetryHistoryResponses,
    GetTelemetryHistoryErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/telemetry/{propertyId}/history",
    ...options,
  })

/**
 * Get latest telemetry point
 */
export const getLatestTelemetry = <ThrowOnError extends boolean = false>(
  options: Options<GetLatestTelemetryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLatestTelemetryResponses,
    GetLatestTelemetryErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
      { name: "x-sixb-share-grant", type: "apiKey" },
    ],
    url: "/api/objects/{objectTypeId}/{objectId}/telemetry/{propertyId}/latest",
    ...options,
  })

/**
 * Read domain events
 */
export const listEvents = <ThrowOnError extends boolean = false>(
  options?: Options<ListEventsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListEventsResponses, ListEventsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/events",
    ...options,
  })

/**
 * Read run logs
 */
export const listLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListLogsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListLogsResponses, ListLogsErrors, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/api/logs",
    ...options,
  })

/**
 * List all projection definitions
 */
export const listProjections = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListProjectionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/projections",
    ...options,
  })

/**
 * Get a projection definition by id
 */
export const getProjection = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectionData, ThrowOnError>
) =>
  (options.client ?? client).get<GetProjectionResponses, GetProjectionErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/projections/{projectionId}",
    ...options,
  })

/**
 * List projection run history
 */
export const listProjectionRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectionRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListProjectionRunsResponses,
    ListProjectionRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/projection-runs",
    ...options,
  })

/**
 * Get a projection run by id
 */
export const getProjectionRun = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectionRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetProjectionRunResponses, GetProjectionRunErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/projection-runs/{runId}",
    ...options,
  })

/**
 * List webhook run history
 */
export const listWebhookRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListWebhookRunsResponses, ListWebhookRunsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/webhook-runs",
    ...options,
  })
